<script lang="ts">import { goto } from "$app/navigation";
import { page } from "$app/stores";
import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { depositingCrypto, isBetbyDisplayed, isFullScreenGame, isGamePlaying, isPlayerChatOpen, loggedIn, ModalDialog, pushModal, selectedItemMobileMenu, stateDepositBonusOffers, stateOpenModal, stateShowSidebarMobile, stateVipState, toSiteUrl } from "@infinitro/global";
import { walletStore } from "@infinitro/global/wallet";
import { RemoteIcon } from "@infinitro/icons";
export let menuItem;
export let onClickMenu = () => null;
export let onClickChat = () => null;
export let onClickSearch = () => null;
export let showFullScreenOnChatSlot = false;
export let isMenuCollapsed = false;
let active = false;
let href = "";
const DEFAULT_DEPOSIT_THRESHOLD_USD = 20;
$: layoutConfig = $stateUi.layout;
$: centralButtonDepositThresholdUsd = layoutConfig.centralButtonDepositThresholdUsd ?? DEFAULT_DEPOSIT_THRESHOLD_USD;
$: selectedWalletUsdBalance = Number($walletStore?.toUsd($walletStore?.balance ?? 0) ?? 0);
$: showDepositCentralButton = menuItem.key === "rewards" && $isGamePlaying && !!$walletStore && selectedWalletUsdBalance <= centralButtonDepositThresholdUsd;
$: availableRewardsCount = ($stateDepositBonusOffers?.length ?? 0) + ($stateVipState?.rewards?.reduce((acc, reward) => reward.claimReady ? acc + 1 : acc, 0) ?? 0);
$: showRewardsGlow = menuItem.key === "rewards" && !showDepositCentralButton && availableRewardsCount > 0;
$: displayedMenuItemName = showDepositCentralButton ? Verbiage.deposit : menuItem.name;
$: displayedMenuItemIcon = showDepositCentralButton ? "MobileDepositIcon" : menuItem.icon ?? "";
$: {
	const isMenuOpen = $stateShowSidebarMobile;
	const isChatOpen = !showFullScreenOnChatSlot && $isPlayerChatOpen;
	const hasOverlayActive = isMenuOpen || isChatOpen;
	if (menuItem.key !== "menu" && menuItem.key !== "chat") {
		href = toSiteUrl(menuItem.href, $loggedIn);
		const selectedNavigationItem = $selectedItemMobileMenu === "sports" || $selectedItemMobileMenu === "promo" || $selectedItemMobileMenu === "casino" ? $selectedItemMobileMenu : null;
		const isRouteActive = href === $page.url.pathname || menuItem.key === "sports" && $page.url.pathname.includes("/sports/") || menuItem.key === "casino" && $page.url.pathname.includes("/casino/") || menuItem.key === "fomo-points" && $page.url.pathname.includes("/tournaments/") || menuItem.key === "promo" && $page.url.pathname.includes("promotion") || menuItem.key === "turbo-bets" && $page.url.pathname.includes("/special-bets/");
		active = !hasOverlayActive && (selectedNavigationItem ? selectedNavigationItem === menuItem.key : isRouteActive);
	} else {
		active = menuItem.key === "menu" ? isMenuOpen : showFullScreenOnChatSlot ? false : isChatOpen;
	}
}
const sportsClick = (e) => {
	e.preventDefault();
	e.stopPropagation();
	stateShowSidebarMobile.set(false);
	const sportsHref = toSiteUrl("/sports/", $loggedIn);
	if (!$isBetbyDisplayed) {
		goto(sportsHref);
	}
	return false;
};
const rewardsClick = (e) => {
	e.preventDefault();
	e.stopPropagation();
	stateOpenModal.set(ModalDialog.RewardsDropdown);
	return false;
};
const depositClick = (e) => {
	e.preventDefault();
	e.stopPropagation();
	depositingCrypto.set(true);
	pushModal(ModalDialog.Cashier);
	return false;
};
const blurActiveEditable = () => {
	const activeElement = document.activeElement;
	if (!(activeElement instanceof HTMLElement)) return;
	const tag = activeElement.tagName;
	const isEditable = activeElement.isContentEditable || tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT";
	if (isEditable) activeElement.blur();
};
function handleClick(e) {
	const itemKey = menuItem.key ?? "";
	if (menuItem.key === "menu") {
		blurActiveEditable();
	}
	if ([
		"menu",
		"sports",
		"promo",
		"casino",
		"chat"
	].includes(itemKey)) {
		selectedItemMobileMenu.set(itemKey);
	}
	if (menuItem.key !== "chat" && menuItem.key !== "menu") {
		isPlayerChatOpen.set(false);
	}
	if (menuItem.key !== "menu") {
		stateShowSidebarMobile.set(false);
	}
	if (showDepositCentralButton) {
		depositClick(e);
		return;
	}
	switch (menuItem.key) {
		case "sports":
			sportsClick(e);
			break;
		case "menu":
			onClickMenu();
			break;
		case "chat":
			onClickChat();
			break;
		case "search":
			onClickSearch();
			break;
		case "rewards":
			rewardsClick(e);
			break;
		default:
			if (href) {
				goto(href);
			}
			break;
	}
}
const iconSize = 20;
$: useAlternative = $stateUi.mobileMenu.mobileMenuStyle === "alternative";
$: useAlternative2 = $stateUi.mobileMenu.mobileMenuStyle === "alternative2";
$: useAlternative4 = $stateUi.mobileMenu.mobileMenuStyle === "alternative4";
</script>

<div class="central-item">
	<div class="central-button-wrapper">
		<button
			class="central-button"
			class:central-button-deposit={showDepositCentralButton}
			class:central-button-rewards-glow={showRewardsGlow}
			aria-label={$t(displayedMenuItemName)}
			type="button"
			on:click={handleClick}
		>
			{#key displayedMenuItemIcon}
				<RemoteIcon icon={displayedMenuItemIcon} size={iconSize} active={true} color="white" />
			{/key}
		</button>
	</div>
	{#if !isMenuCollapsed}
		<span
			class="text {active ? 'active' : ''}"
			class:text-alternative={useAlternative || useAlternative4}
			class:active-alternative={(useAlternative || useAlternative4) && active}
			class:active-alternative2={useAlternative2 && active}
		>
			{$t(displayedMenuItemName)}
		</span>
	{/if}
</div>

<style>
	.central-item {
		position: relative;
		margin-top: -20px;
		display: flex;
		height: 80px;
		width: 100%;
		flex-direction: column;
		align-items: center;
		justify-content: flex-end;
}

	.central-button-wrapper {
		position: absolute;
		left: 50%;
		z-index: 1200;
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		bottom: 28px;
}

	.central-button {
		height: 38px;
		width: 38px;
		min-width: 0px;
		cursor: pointer;
		border-radius: 9999px;
		border-width: 1px;
		border-color: rgb(255 255 255 / 0.3);
		padding: 0px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid var(--color-neutral-900);
		background-image: linear-gradient(
			180deg,
			var(--color-primary-500) 0%,
			var(--color-primary-700) 50%,
			var(--color-primary-900) 100%
		);
}

	.central-button:hover {
		background-image: linear-gradient(
			180deg,
			var(--color-primary-500) 0%,
			var(--color-primary-700) 74%,
			var(--color-primary-900) 100%
		);
	}

	.central-button:active {
		border-style: none;
		box-shadow:
			inset 0px 2px 2px 0px rgba(0, 0, 0, 0.55),
			0px -5px 6px 0px #00000040 inset,
			0px 5px 6px 0px #ffffff40 inset;
}

	.central-button-deposit {
		animation: central-button-pulse 1.8s ease-in-out infinite;
	}

	.central-button-rewards-glow {
		box-shadow:
			0 0 6px rgb(var(--color-primary-500-rgb) / 0.5),
			0 0 14px rgb(var(--color-primary-500-rgb) / 0.6);
		animation: central-button-rewards-glow 2s ease-in-out infinite;
	}

	@keyframes central-button-pulse {
		0% {
			transform: scale(1);
			box-shadow: 0 0 0 0 rgb(255 255 255 / 0.4);
		}
		50% {
			transform: scale(1.06);
			box-shadow: 0 0 0 10px rgb(255 255 255 / 0);
		}
		100% {
			transform: scale(1);
			box-shadow: 0 0 0 0 rgb(255 255 255 / 0);
		}
	}

	@keyframes central-button-rewards-glow {
		0% {
			box-shadow:
				0 0 4px rgb(var(--color-primary-500-rgb) / 0.35),
				0 0 10px rgb(var(--color-primary-500-rgb) / 0.45);
		}
		50% {
			box-shadow:
				0 0 8px rgb(var(--color-primary-500-rgb) / 0.65),
				0 0 18px rgb(var(--color-primary-500-rgb) / 0.8);
		}
		100% {
			box-shadow:
				0 0 4px rgb(var(--color-primary-500-rgb) / 0.35),
				0 0 10px rgb(var(--color-primary-500-rgb) / 0.45);
		}
	}

	.text {
		position: relative;
		top: -8px;
		height: 1rem;
		white-space: nowrap;
		font-size: 10px;
		font-weight: 600;
		line-height: .75rem;
		letter-spacing: 1px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

	.text-alternative {
		text-align: center;
		font-size: 12px;
		font-weight: 400;
		color: var(--color-text-700);
		height: unset;
}

	.active {
		color: var(--color-primary-500);
}
	.active-alternative {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
	.active-alternative2 {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
</style>
